export const isBetsukanriInHokkaido = (asset) => {
  if (asset.jointCmpanyCd == '33') {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./lib/isBetsukanriInHokkaido.js